import classNames from 'classnames';
import React from 'react';

import styles from './LoadingSpinner.module.css';

type LoadingSpinnerProps = {
    size?: 'default' | 'full-width';
    subdued?: boolean;
    speed?: 'slow' | 'normal';
    color?: 'default' | 'disabled';
    backgroundColor?: 'default' | 'darken';
};

const LoadingSpinner = ({
    size = 'default',
    subdued = false,
    speed = 'normal',
    color = 'default',
    backgroundColor = 'default',
}: LoadingSpinnerProps) => {
    return (
        <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className={classNames(styles.Root, {
                [styles.sizeDefault]: size === 'default',
            })}
        >
            <path
                d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                className={classNames({
                    [styles.Background_default]: backgroundColor === 'default',
                    [styles.Background_darken]: backgroundColor === 'darken',
                    [styles.Background_disabled]: color === 'disabled',
                })}
            />
            <path
                d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
                className={classNames(styles.Spinner, {
                    [styles.Spinner_subdued]: subdued,
                    [styles.Spinner_slow]: speed === 'slow',
                    [styles.Spinner_disabled]: color === 'disabled',
                })}
                strokeLinecap="square"
            />
        </svg>
    );
};

export default LoadingSpinner;
